import type { AvatarKey } from '@sincronia/shared';

export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}

/**
 * Cada jogador tem cor E forma: a identificação nunca depende só da cor.
 */
export const AVATAR_STYLES: Record<AvatarKey, { color: string; glyph: GlyphName; label: string }> =
  {
    aurora: { color: 'var(--color-player-aurora)', glyph: 'circle', label: 'círculo' },
    citrino: { color: 'var(--color-player-citrino)', glyph: 'diamond', label: 'losango' },
    coral: { color: 'var(--color-player-coral)', glyph: 'triangle', label: 'triângulo' },
    jade: { color: 'var(--color-player-jade)', glyph: 'square', label: 'quadrado' },
    lilas: { color: 'var(--color-player-lilas)', glyph: 'hexagon', label: 'hexágono' },
    oceano: { color: 'var(--color-player-oceano)', glyph: 'wave', label: 'onda' },
    brasa: { color: 'var(--color-player-brasa)', glyph: 'star', label: 'estrela' },
    neve: { color: 'var(--color-player-neve)', glyph: 'cross', label: 'cruz' },
  };

export type GlyphName =
  'circle' | 'diamond' | 'triangle' | 'square' | 'hexagon' | 'wave' | 'star' | 'cross';

export const GLYPH_PATHS: Record<GlyphName, string> = {
  circle: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z',
  diamond: 'M12 3l9 9-9 9-9-9 9-9z',
  triangle: 'M12 4l9 16H3l9-16z',
  square: 'M5 5h14v14H5z',
  hexagon: 'M12 3l7.5 4.5v9L12 21l-7.5-4.5v-9L12 3z',
  wave: 'M3 14c3-6 6 6 9 0s6 6 9 0v4c-3 6-6-6-9 0s-6-6-9 0v-4z',
  star: 'M12 3l2.7 6.1 6.6.6-5 4.4 1.5 6.5L12 17.3 6.2 20.6l1.5-6.5-5-4.4 6.6-.6L12 3z',
  cross: 'M9 3h6v6h6v6h-6v6H9v-6H3V9h6V3z',
};

export function avatarColor(key: AvatarKey): string {
  return AVATAR_STYLES[key]?.color ?? 'var(--color-player-aurora)';
}

/** Iniciais curtas para os chips compactos (até 8 jogadores). */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return (parts[0] ?? '').slice(0, 2).toUpperCase();
  return `${(parts[0] ?? '')[0] ?? ''}${(parts[1] ?? '')[0] ?? ''}`.toUpperCase();
}
